<template>
        <el-dialog :visible.sync="dialogVisible" width="65%" top="60px" :fullscreen="dialogFull"
                :close-on-click-modal="false" :destroy-on-close="true" append-to-body :modal-append-to-body="false">
                <template slot="title">
                        <div class="avue-crud__dialog__header">
                                <span class="el-dialog__title">
                                        {{title}}
                                </span>
                                <i class="el-icon-full-screen" style="margin-right:20px;position:relative;top:-1px"
                                        @click="dialogFull=!dialogFull"></i>

                        </div>
                </template>
                <avue-form ref="form" @submit="submit" v-loading="loading" v-model="form" :upload-before="uploadBefore"
                        :upload-error="uploadError" :upload-after="uploadAfter" v-if="dialogVisible" :option="option">
                        <template slot="spaceId">
                                <el-select v-model="form.spaceId" placeholder="请选择 车场名称" :disabled="title!='新增'">
                                        <el-option v-for="item in spaceList" :key="item.key" :label="item.title"
                                                :value="item.key">
                                        </el-option>
                                </el-select>
                        </template>
                        <template slot="buyStartTime">
                                <el-date-picker @change="initShoudMoney" v-model="form.buyStartTime" type="date"
                                        value-format='yyyy-MM-dd 00:00:00' placeholder="请选择 租赁起期">
                                </el-date-picker>
                        </template>
                        <template slot="ruleId">
                                <el-select v-model="form.ruleId" @change="initShoudMoney" placeholder="请选择 收费套餐">
                                        <el-option v-for="item in ruleIdList" :key="item.id" :label="item.remark"
                                                :value="item.id">
                                        </el-option>
                                </el-select>
                        </template>
                        <template slot="carClass">
                                <el-select v-model="form.carClass" placeholder="请选择 车辆分类" :disabled="title=='新增'">
                                        <el-option v-for="item in carClassList" :key="item.id" :label="item.dictValue"
                                                :value="item.dictKey">
                                        </el-option>
                                </el-select>
                        </template>
                        <template slot="carType">
                                <el-select v-model="form.carType" placeholder="请选择 车辆类型" :disabled="title=='新增'">
                                        <el-option v-for="item in carTypeList" :key="item.id" :label="item.dictValue"
                                                :value="item.dictKey">
                                        </el-option>
                                </el-select>
                        </template>
                        <template slot="cycleNum">
                                <el-select v-model="form.cycleNum" @change="initShoudMoney" placeholder="请选择 续租时长"
                                        :disabled="title=='新增'">
                                        <el-option v-for="item in carMonthPackageList" :key="item.id"
                                                :label="item.dictValue" :value="item.dictKey">
                                        </el-option>
                                </el-select>
                        </template>
                        <template slot="status">
                                <el-select v-model="form.status" placeholder="请选择 状态" :disabled="title=='新增'">
                                        <el-option v-for="item in carMonthStatusist" :key="item.id"
                                                :label="item.dictValue" :value="item.dictKey">
                                        </el-option>
                                </el-select>
                        </template>
                </avue-form>
                <template slot="footer">
                        <el-button @click="formSubmit1" :disabled="disabled" size="small" type="primary"><span class="el-icon-check"></span>
                                保存</el-button>
                        <el-button @click="handleClose" :disabled="disabled" size="small" style="margin-right:15px"><span
                                        class="el-icon-close"></span> 取消</el-button>
                </template>
        </el-dialog>
</template>
<script>
import option from "./carmonthRenior-form.js"
import { getCarParkList } from "@/api/v4ward/car/carcharge.js"
import { getDictionary } from "@/api/common.js"
// import {nodeTreeByParentId} from "@/api/v4ward/car/carmonth.js"
import {
        addRenior,
        getDetailAndOperate,
        getcarMonthLastEndTime,
        getMainList,
        remove,
        synchronize,
        synchronizePlus,
        update,
        loadCarPayBackAmount,
        loadCarPayAmount,
        getDetail,
        copyCarmonth,
        loadCarPayMonthCarNo,
        nodeTreeByParentId,
        getListTempStopUnPayList,
        exportMonthCarList,
} from '@/api/v4ward/car/carmonth';
import { monthChargeRuleList } from '@/api/v4ward/car/carmonthchargerule';
export default {
        data() {
                return {
                        loading: false,
                        dialogVisible: false,
                        dialogFull: false,
                        option: option,
                        title: '编 辑',
                        form: {
                                spaceId: '',
                                regions: '',
                                ruleId: '',
                                cycleNum: '',
                                buyStartTime: '',
                                backAmount: '',
                        },
                        spaceList: [],
                        carClassList: [],
                        carTypeList: [],
                        carMonthPackageList: [],
                        carMonthStatusist: [],
                        ruleIdList: [],
                        disabled:false,
                }
        },
        created() {
                this.initData();
        },
        methods: {
                formSubmit1() {
                        this.disabled = true;
                        this.$refs.form.submit();
                        setTimeout(()=>{
                                this.disabled = false;
                        },5000)
                },
                submit(row,done) {
                        if(this.title=='编 辑'){
                                update(row).then(() => {
                                        this.$message.success('操作成功!');
                                        this.disabled = false
                                        this.$emit('onLoad')
                                        this.dialogVisible = false;
                                        done();
                                },
                                        (error) => {
                                                this.disabled = false
                                                window.console.log(error);
                                                done();
                                        }
                                );
                        }

                },
                openDialog(row, type = 'add') {
                        const loading = this.$loading({
                                lock: true,
                                text: 'Loading',
                                spinner: 'el-icon-loading',
                                background: 'rgba(0, 0, 0, 0.7)',
                                zIndex: 6000
                        });
                        this.loading = true;
                        if (type == 'edit') {
                                this.title = '编 辑';
                                this.getDetail(row, loading)

                        } else if (type == 'view') {
                                this.title = '查 看'
                                this.getDetail(row, loading)
                        } else {
                                this.title = '新 增'
                                this.loading = false;
                        }
                        this.dialogVisible = true;
                },
                handleClose() {
                        this.dialogVisible = false;
                },
                getDetail(row, loading) {
                        getDetail({ id: row.id }).then(({ data }) => {
                                data.status = String(data.status);
                                data.cycleNum = String(data.cycleNum);
                                data.carType = String(data.carType);
                                data.carClass = String(data.carClass);
                                this.form = this._.cloneDeep(data);
                                if (this.vdui.isEmpty(this.form.backAmount)) {
                                        this.form.backAmount = 0;
                                }
                                this.nodeTreeByParentId(this.form.spaceId)
                                loading.close()
                                this.loading = false;
                        }).catch(err => {
                                this.loading = false;
                        })
                },
                // 获取区域
                nodeTreeByParentId(spaceId) {
                        // 获取同行区域
                        nodeTreeByParentId(spaceId).then(res => {
                                let regions = this.findObject(this.option.column, 'regions');
                                regions.dicData = res.data;
                        })
                        // 获取收费套餐
                        if (this.form.spaceId != null && this.form.spaceId != '' && this.form.spaceId != undefined) {
                                monthChargeRuleList(Object.assign({ spaceId: this.form.spaceId })).then(({ data }) => {
                                        // const column = this.findObject(this.option.column, 'ruleId');
                                        // column.dicData = data;
                                        this.ruleIdList = data
                                });
                        }
                },
                // 计算金额
                initShoudMoney() {
                        console.log('执行了....')
                        if (this.vdui.isNotEmpty(this.form.cycleNum)) {
                                if (this.vdui.isEmpty(this.form.ruleId)) {
                                        this.$message.error('收费规则不得为空');
                                        return;
                                }
                                loadCarPayAmount({
                                        ruleId: this.form.ruleId,
                                        cycleNum: this.form.cycleNum,
                                        startTime: this.form.buyStartTime,
                                        backAmount: this.form.backAmount,
                                        backType: 3,
                                }).then(({ data }) => {
                                        //若为办公车则应收实收金额为0
                                        if (this.form.carClass == 2) {
                                                this.form.shouldMoney = 0;
                                                this.form.payMoney = 0;
                                        } else {
                                                this.form.shouldMoney = data.shouldAmount;
                                                this.form.payMoney = data.shouldAmount;
                                        }
                                        if (this.changeBuyEndTime) {
                                                this.form.buyEndTime = data.endTime + ' 23:59:59';
                                        }
                                });
                        } else {
                                if (!this.form.shouldMoney) {
                                        this.form.shouldMoney = 0;
                                }
                                if (!this.form.payMoney) {
                                        this.form.payMoney = 0;
                                }
                                return;
                                // this.form.shouldMoney = 0;
                        }
                },
                // 初始化字典值
                initData() {
                        // getCarParkList().then(res=>{
                        //         this.spaceList = res.data;
                        // })
                        getDictionary('car_class').then(res => {
                                this.carClassList = res.data;
                        })
                        getDictionary('car_type').then(res => {
                                this.carTypeList = res.data;
                        })
                        getDictionary('car_month_package').then(res => {
                                this.carMonthPackageList = res.data;
                        })
                        getDictionary('car_month_status').then(res => {
                                this.carMonthStatusist = res.data;
                        })

                },
                uploadBefore(file, done, loading) {
                        // console.log(file.name.split('.'));
                        let len = file.name.split('.').length;
                        // console.log(file.name.split('.')[len-1]);
                        console.log(
                                file.name.split('.')[len - 1] === 'png' || file.name.split('.')[len - 1] === 'jpeg'
                        );
                        console.log(file.type === 'image/jpeg' || file.type === 'image/png');
                        console.log(file.type);
                        const isImage =
                                (file.name.split('.')[len - 1] === 'png' || file.name.split('.')[len - 1] === 'jpg') &&
                                (file.type === 'image/jpeg' || file.type === 'image/png');
                        console.log(isImage);
                        const isLt500KB = file.size / 1024 < 500;
                        if (!isImage) {
                                this.$message.error('只能上传jpg/png格式的图片');
                                loading();
                                return;
                        }
                        if (!isLt500KB) {
                                this.$message.error('上传图片大小不能超过500kb!');
                                loading();
                                return;
                        }
                        if (isImage && isLt500KB) {
                                done();
                        }
                },
        }
}
</script>
